import { Box, Grid, Switch, Typography } from "@mui/material";
import React from "react";
import {
  blackColor,
  blackShade05,
  blackShade07,
  blueColor04,
  displaySwitchGreenColor,
  displaySwitchRedColor,
  greyColor24,
  greyColor41,
  greyColor52,
  greyColor6,
  greyColor7,
  lightGreen04,
  lightRedColor02,
  logoImgborder,
  redColor01,
  whiteColor,
} from "../../configs/styles/muiThemes";
import StyledReadOnlySwitch from "../../components/Switch/StyledReadOnlySwitch";
import InputPreview from "../../components/Input/InputPreview";
import moment from "moment";
import { toTitleCase } from "../../utils/validationUtils";
import StyledSwitch from "../../components/Switch/StyledSwitch";
import styled from "@emotion/styled";

const ONDCControlsPreview = ({
  ondcEnabled,
  ondcDomain,

  ondcSupportRegion,
  ondcSupportDistanceKm,
  ondcBPPFulfillments,
  ondcCustomerDiscountEnabled,

  ondcMinOrder,
  packagingCost,
  convenienceFee,
  ondcBuyerFinderFeeUpperLimitPercentage,

  ondcPartialCancellationStage,
  ondcFullCancellationStage,

  autoApprovalEnabled,

  storeDays,
  storeStartTime,
  storeEndTime,
  breakStartTime,
  breakEndTime,
  holidayStartDate,
  holidayEndDate,

  isOpen24Hr,
  storeTimeList,

  buyerLinks,

  // ONDC Shipment Method
  isONDCShipmentEnabled,
  shipmentMethods,
  shippingMetrics,
  ondcLspProviders,
  preferredLsps,
  rejectedLsps,
  costIncrementalPercentage,
  currentPage,
}) => {
  const getOrderStatusText = (status) => {
    switch (status) {
      case "ordercreated":
        return "Order Created";
      case "orderapproved":
        return "Order Approved";
      case "ordershipped":
        return "Order Shipped";

      default:
        return "";
    }
  };

  const getOndcShipmentNameByCode = (code) => {
    switch (code) {
      case "IMMEDIATEDELIVERY":
        return "Immediate Delivery";
      case "NEXTDAYDELIVERY":
        return "Next Day Delivery";
      case "SAMEDAYDELIVERY":
        return "Same Day Delivery";
      case "STANDARDDELIVERY":
        return "Standard Delivery";

      default:
        return "";
    }
  };

  return (
    <>
      <Box sx={{ ...styles.section, pt: 1, mt: { xs: 2, md: 1 } }}>
        <Typography
          component="h5"
          fontSize={{ xs: 14.5, md: 14 }}
          // borderBottom={"1px solid " + greyColor41}
          color={blackColor}
          fontWeight={600}
          lineHeight="20px"
          m={{ xs: "10px 0 !important", md: "10px 0 10px !important" }}
        >
          Category & Shipments
        </Typography>

        <Grid container rowSpacing={{ xs: 2, md: 2 }} columnSpacing={3}>
          <Grid item xs={12} md={3.5}>
            <Typography
              fontSize={13}
              fontWeight={400}
              color={greyColor6}
              mb={{ xs: 1, md: 1 }}
            >
              ONDC Enabled{" "}
            </Typography>
            {/* <StyledReadOnlySwitch isEnabled={ondcEnabled} /> */}
            <Typography
              component="body2"
              fontSize={13}
              color={
                ondcEnabled ? displaySwitchGreenColor : displaySwitchRedColor
              }
              fontWeight={500}
              lineHeight="20px"
              // display={{ xs: "block", md: "none" }}
              sx={{
                textDecoration: "underline",
                bgcolor: ondcEnabled ? lightGreen04 : lightRedColor02,
                p: "4px 15px",
                borderRadius: "6px",
              }}
            >
              {ondcEnabled ? "Yes" : "No"}
            </Typography>
          </Grid>
        </Grid>

        <Box my={2}>
          <Typography
            fontSize={13}
            fontWeight={400}
            color={greyColor6}
            mb={{ xs: 0, md: 1 }}
          >
            ONDC Category
          </Typography>

          <Grid container rowSpacing={{ xs: 0.5, md: 2 }} columnSpacing={3}>
            {ondcDomain?.split(",")?.map((item, index) => {
              return (
                <Grid item xs={12} md={3} key={`${item}_${index}`}>
                  <ListData value={item} />
                </Grid>
              );
            })}
          </Grid>
        </Box>

        {/* <Typography
          component="h6"
          fontSize={{ xs: 14, md: 14 }}
          // borderBottom={"1px solid " + greyColor41}
          color={blackColor}
          fontWeight={600}
          lineHeight="20px"
          m={{ xs: "5px 0 10px !important", md: "5px 0 15px !important" }}
        >
          Shipments & Discounts
        </Typography>

        <Grid container rowSpacing={{ xs: 1, md: 2 }} columnSpacing={3}>
          <Grid item xs={12} md={3}>
            <InputPreview
              label="Shipment Region"
              value={toTitleCase(ondcSupportRegion || "")}
              hideBorder
              styles={styles.labelStyles}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <InputPreview
              label="Shipment Distance"
              value={ondcSupportDistanceKm}
              hideBorder
              styles={styles.labelStyles}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <InputPreview
              label="Delivery Methods"
              value={ondcBPPFulfillments}
              hideBorder
              styles={styles.labelStyles}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <InputPreview
              label="Customer Discount"
              value={ondcCustomerDiscountEnabled}
              hideBorder
              styles={styles.labelStyles}
            />
          </Grid>
        </Grid> */}
      </Box>

      <Box sx={styles.section}>
        <Typography
          component="h5"
          fontSize={{ xs: 14.5, md: 14 }}
          // borderBottom={"1px solid " + greyColor41}
          color={blackColor}
          fontWeight={600}
          lineHeight="20px"
          m={{ xs: "15px 0 !important", md: "18px 0 10px !important" }}
        >
          Shipments Controls
        </Typography>

        <Grid container rowSpacing={{ xs: 1, md: 2 }} columnSpacing={3}>
          <Grid item xs={12} md={2.5}>
            <InputPreview
              label="Shipment Region"
              value={toTitleCase(ondcSupportRegion || "")}
              hideBorder
              styles={styles.labelStyles}
            />
          </Grid>

          <Grid item xs={12} md={2.5}>
            <InputPreview
              label="Shipment Distance"
              value={ondcSupportDistanceKm}
              hideBorder
              styles={styles.labelStyles}
            />
          </Grid>

          {/* <Grid item xs={12} md={3}>
            <InputPreview
              label="Delivery Methods"
              value={ondcBPPFulfillments}
              hideBorder
              styles={styles.labelStyles}
            />
          </Grid> */}

          {/* <Grid item xs={12} md={3}>
            <InputPreview
              label="Customer Discount"
              value={ondcCustomerDiscountEnabled}
              hideBorder
              styles={styles.labelStyles}
            />
          </Grid> */}
        </Grid>

        <Typography
          component="h5"
          fontSize={{ xs: 14.5, md: 14 }}
          // borderBottom={"1px solid " + greyColor41}
          color={blackColor}
          fontWeight={600}
          lineHeight="20px"
          m={{ xs: "10px 0 0px !important", md: "10px 0 10px !important" }}
        >
          Shipment Methods
        </Typography>

        {!isONDCShipmentEnabled ? (
          <StyledReadOnlySwitch isEnabled={false} />
        ) : (
          <>
            {shipmentMethods?.map((item) => {
              if (item?.min >= 0 && item?.max >= 0) {
                if (currentPage == "preview" && !item?.isEnabled) return null;
                return (
                  <ShipmentMethodInfo
                    key={item?.code}
                    shipmentMethodName={getOndcShipmentNameByCode(item?.code)}
                    isEnabled={true}
                    fromDistance={item?.min || "0"}
                    toDistance={item?.max || 0}
                  />
                );
              }
            })}

            <Typography
              component="h5"
              fontSize={{ xs: 14.5, md: 14 }}
              // borderBottom={"1px solid " + greyColor41}
              color={blackColor}
              fontWeight={600}
              lineHeight="20px"
              m={{ xs: "20px 0 0 !important", md: "10px 0 0px !important" }}
            >
              Shipping Preferences
            </Typography>

            <Typography
              component="h5"
              fontSize={{ xs: 13, md: 13 }}
              // borderBottom={"1px solid " + greyColor41}
              color={blackColor}
              fontWeight={600}
              lineHeight="20px"
              m={{ xs: "10px 0 15px !important", md: "10px 0 10px !important" }}
            >
              Logistics Partner
            </Typography>

            <Grid container rowSpacing={{ xs: 2, md: 2 }} columnSpacing={3}>
              <Grid item xs={12} md={6}>
                <ShipmentPreferenceDetails
                  label="Preferred"
                  selectedLsps={preferredLsps}
                  ondcLspProviders={ondcLspProviders}
                  bgcolor={lightGreen04}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <ShipmentPreferenceDetails
                  label="Not Preferred"
                  selectedLsps={rejectedLsps}
                  ondcLspProviders={ondcLspProviders}
                  bgcolor={lightRedColor02}
                />
              </Grid>
            </Grid>

            <Typography
              fontSize={{ xs: 12.5, md: 13 }}
              fontWeight={600}
              color={blueColor04}
              lineHeight="20px"
              m="15px 0 18px"
            >
              If preferred logistics partner is not available, we will default
              to next best available choice
            </Typography>

            <Grid container rowSpacing={{ xs: 1, md: 1 }} columnSpacing={3}>
              <Grid item xs={12} md={3}>
                <InputPreview
                  label="Shipping Options"
                  value="Low Cost"
                  hideBorder
                  styles={styles.labelStyles}
                />
              </Grid>

              <Grid item xs={12} md={8}></Grid>

              <Grid item xs={12} md={3}>
                <InputPreview
                  label="Max % incremental"
                  value={`${costIncrementalPercentage}%`}
                  hideBorder
                  styles={styles.labelStyles}
                />
              </Grid>
            </Grid>
          </>
        )}
      </Box>

      <Box sx={styles.section}>
        <Typography
          component="h6"
          fontSize={{ xs: 14.5, md: 14 }}
          // borderBottom={"1px solid " + greyColor41}
          color={blackColor}
          fontWeight={600}
          lineHeight="20px"
          m={{ xs: "15px 0 10px !important", md: "20px 0 10px !important" }}
        >
          Pricing Controls
        </Typography>

        <Grid container rowSpacing={{ xs: 1, md: 2 }} columnSpacing={3}>
          <Grid item xs={12} md={3}>
            <InputPreview
              label="Minimum Order Amount"
              value={`₹ ${ondcMinOrder}`}
              hideBorder
              styles={styles.labelStyles}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <InputPreview
              label="Packing Cost"
              value={`₹ ${packagingCost}`}
              hideBorder
              styles={styles.labelStyles}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <InputPreview
              label="Convenience Fee"
              value={`₹ ${convenienceFee}`}
              hideBorder
              styles={styles.labelStyles}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <InputPreview
              label="Buyer Finder Fee Limit"
              value={ondcBuyerFinderFeeUpperLimitPercentage}
              hideBorder
              styles={styles.labelStyles}
            />
          </Grid>
        </Grid>
      </Box>

      <Box sx={styles.section}>
        <Typography
          component="h6"
          fontSize={{ xs: 14.5, md: 14 }}
          // borderBottom={"1px solid " + greyColor41}
          color={blackColor}
          fontWeight={600}
          lineHeight="20px"
          m={{ xs: "15px 0 10px !important", md: "20px 0 10px !important" }}
        >
          Approval Settings
        </Typography>

        <Typography
          component="h6"
          fontSize={{ xs: 13, md: 14 }}
          color={blackColor}
          fontWeight={600}
          lineHeight="20px"
          m={{ xs: "10px 0 10px !important", md: "10px 0 15px !important" }}
        >
          Cancel Terms
        </Typography>

        <Grid container rowSpacing={{ xs: 1, md: 2 }} columnSpacing={3}>
          <Grid item xs={12} md={3}>
            <InputPreview
              label="Partial Cancel Stage"
              value={getOrderStatusText(ondcPartialCancellationStage)}
              hideBorder
              styles={styles.labelStyles}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <InputPreview
              label="Full Cancel Stage"
              value={getOrderStatusText(ondcFullCancellationStage)}
              hideBorder
              styles={styles.labelStyles}
            />
          </Grid>
        </Grid>

        <Typography
          component="h6"
          fontSize={{ xs: 13, md: 14 }}
          color={blackColor}
          fontWeight={600}
          lineHeight="20px"
          m={{ xs: "10px 0 10px !important", md: "5px 0 15px !important" }}
        >
          Auto Approval
        </Typography>

        <Grid container rowSpacing={{ xs: 1, md: 2 }} columnSpacing={3}>
          <Grid item xs={12} md={3}>
            <InputPreview
              label="Auto Approval"
              value={autoApprovalEnabled}
              hideBorder
              styles={styles.labelStyles}
            />
          </Grid>
        </Grid>
      </Box>

      <Box sx={styles.section}>
        <Typography
          component="h6"
          fontSize={{ xs: 14.5, md: 14 }}
          // borderBottom={"1px solid " + greyColor41}
          color={blackColor}
          fontWeight={600}
          lineHeight="20px"
          m={{ xs: "15px 0 10px !important", md: "20px 0 10px !important" }}
        >
          Timings & Holiday
        </Typography>

        <Typography
          component="h6"
          fontSize={{ xs: 13, md: 14 }}
          color={blackColor}
          fontWeight={600}
          lineHeight="20px"
          m={{ xs: "10px 0 10px !important", md: "5px 0 10px !important" }}
        >
          Store Days
        </Typography>

        <Grid container rowSpacing={{ xs: 1, md: 2 }} columnSpacing={3}>
          {storeDays?.map((item, index) => {
            return (
              <Grid item xs={6} md={3} key={item?.label + index}>
                <InputPreview
                  key={item?.label}
                  label={item?.label}
                  value={
                    item?.isOpen
                      ? isOpen24Hr
                        ? `${moment(storeStartTime, "HH:mm").format(
                            "hh:mm A"
                          )} - ${moment(storeEndTime, "HH:mm").format(
                            "hh:mm A"
                          )}`
                        : "Open"
                      : "Closed"
                  }
                  hideBorder
                  styles={styles.labelStyles}
                />
              </Grid>
            );
          })}
        </Grid>

        <Grid container rowSpacing={{ xs: 1, md: 2 }} columnSpacing={3}>
          <Grid item xs={12} md={6}>
            <Typography
              component="h6"
              fontSize={{ xs: 13, md: 14 }}
              color={blackColor}
              fontWeight={600}
              lineHeight="20px"
              mb={1}
              mt={{ xs: 1, md: 1 }}
            >
              Store Timing
            </Typography>

            <Grid container rowSpacing={{ xs: 2, md: 2 }} columnSpacing={3}>
              {isOpen24Hr ? (
                <>
                  <Grid item xs={6} md={4}>
                    <InputPreview
                      label="Start Time"
                      value={moment(storeStartTime, "HH:mm").format("hh:mm A")}
                      hideBorder
                      styles={styles.labelStyles}
                    />
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <InputPreview
                      label="End Time"
                      value={moment(storeEndTime, "HH:mm").format("hh:mm A")}
                      hideBorder
                      styles={styles.labelStyles}
                    />
                  </Grid>{" "}
                </>
              ) : (
                storeTimeList?.map((item, index) => (
                  <>
                    <Grid item xs={6} md={4} key={"timing_" + index}>
                      <InputPreview
                        label="Start Time"
                        value={moment(item?.storeStartTime, "HH:mm").format(
                          "hh:mm A"
                        )}
                        hideBorder
                        styles={styles.labelStyles}
                      />
                    </Grid>
                    <Grid item xs={6} md={4}>
                      <InputPreview
                        label="End Time"
                        value={moment(item?.storeEndTime, "HH:mm").format(
                          "hh:mm A"
                        )}
                        hideBorder
                        styles={styles.labelStyles}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}></Grid>
                  </>
                ))
              )}
            </Grid>
          </Grid>

          {/* <Grid item xs={12} md={6}>
            <Typography
              component="h6"
              fontSize={{ xs: 13, md: 14 }}
              color={blackColor}
              fontWeight={600}
              lineHeight="20px"
              mb={2}
            >
              Break Timing
            </Typography>

            <Grid container rowSpacing={{ xs: 2, md: 2 }} columnSpacing={3}>
              <Grid item xs={12} md={4}>
                <InputPreview
                  label="Start Date"
                  value={moment(breakStartTime, "HH:mm").format("hh:mm A")}
                  hideBorder
                  styles={styles.labelStyles}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <InputPreview
                  label="End Date"
                  value={moment(breakEndTime, "HH:mm").format("hh:mm A")}
                  hideBorder
                  styles={styles.labelStyles}
                />
              </Grid>
            </Grid>
          </Grid> */}
        </Grid>

        <Typography
          component="h6"
          fontSize={{ xs: 13, md: 14 }}
          color={blackColor}
          fontWeight={600}
          lineHeight="20px"
          mb={0.7}
        >
          Holiday Schedule
        </Typography>

        <Typography
          component="p"
          fontSize={{ xs: 12, md: 12.5 }}
          color={greyColor6}
          fontWeight={400}
          lineHeight="20px"
          mb={2}
        >
          Enter any planned holidays in next 3 months, when the store won't be
          operational
        </Typography>

        <Grid container rowSpacing={{ xs: 2, md: 2 }} columnSpacing={3}>
          <Grid item xs={6} md={3}>
            <InputPreview
              label="Start Date"
              value={
                holidayStartDate
                  ? moment(holidayStartDate)?.format("DD-MM-YYYY")
                  : ""
              }
              hideBorder
              styles={styles.labelStyles}
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <InputPreview
              label="End Date"
              value={
                holidayEndDate
                  ? moment(holidayEndDate)?.format("DD-MM-YYYY")
                  : ""
              }
              hideBorder
              styles={styles.labelStyles}
            />
          </Grid>
        </Grid>
      </Box>

      <Box sx={styles.section}>
        <Typography
          component="h6"
          fontSize={{ xs: 14.5, md: 14 }}
          // borderBottom={"1px solid " + greyColor41}
          pb={0.8}
          color={blackColor}
          fontWeight={600}
          lineHeight="20px"
          m={{ xs: "15px 0 15px !important", md: "20px 0 15px !important" }}
        >
          Buyer App
        </Typography>

        <Grid container rowSpacing={{ xs: 2, md: 2 }} columnSpacing={3}>
          {buyerLinks?.length === 1 &&
          !buyerLinks?.[0]?.code &&
          !buyerLinks?.[0]?.value ? (
            <Grid item xs={12} md={5}>
              <Typography
                component="h6"
                fontSize={13.5}
                color={greyColor7}
                fontWeight={500}
                lineHeight="20px"
                m="-10px 0 15px !important"
              >
                N/A
              </Typography>
            </Grid>
          ) : (
            buyerLinks?.map((buyerLink, index) => (
              <Grid item xs={12} md={12} key={index}>
                <InputPreview
                  label={buyerLink?.displayName}
                  value={buyerLink?.value}
                  hideBorder
                  styles={{
                    ...styles.labelStyles,
                    textTransform: "capitalize",
                  }}
                />
              </Grid>
            ))
          )}
        </Grid>
      </Box>
    </>
  );
};

export default ONDCControlsPreview;

const ListData = ({ value, fontSize }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <Box
        sx={{
          width: { md: "6px", xs: "5px" },
          height: { md: "6px", xs: "5px" },
          borderRadius: "50%",
          backgroundColor: blackShade05,
        }}
      />
      <Typography
        fontSize={fontSize || 13}
        fontWeight={500}
        color={blackShade05}
      >
        {value}
      </Typography>
    </Box>
  );
};

const ShipmentMethodInfo = ({
  shipmentMethodName,
  isEnabled,
  toDistance,
  fromDistance,
}) => {
  return (
    <Box
      mt={{ xs: 1, md: 2 }}
      borderBottom={{ xs: `1px solid ${greyColor52}`, md: "none" }}
      pb={{ xs: 1, md: 0 }}
    >
      <Grid
        container
        rowSpacing={{ xs: 1.5, md: 0 }}
        columnSpacing={{ xs: 2, md: 0 }}
      >
        <Grid item xs={8} md={2.5}>
          <Typography
            component="h5"
            fontSize={{ xs: 12.5, md: 13 }}
            color={blackColor}
            fontWeight={500}
            lineHeight="30px"
            mt={0.4}
          >
            {shipmentMethodName}
          </Typography>
        </Grid>

        <Grid item xs={4} md={1.7}>
          <Box sx={{ display: "flex", alignItems: "center" }} mt={-0.5}>
            <StyledSwitchBlack isChecked={true} onChange={({ target }) => {}} />

            <Typography
              width="50px"
              fontSize={{ xs: 13, md: 13.5 }}
              color={blackShade07}
              fontWeight={500}
              lineHeight="20px"
            >
              {isEnabled ? "Yes" : "No"}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={6} md={2.5}>
          <InputPreview
            label="From Distance (in KM)"
            value={fromDistance}
            hideBorder
            styles={styles.labelStyles}
            valueStyles={{ color: blueColor04 }}
          />
        </Grid>

        <Grid item xs={6} md={2.5}>
          <InputPreview
            label="To Distance (in KM)"
            value={toDistance}
            hideBorder
            styles={styles.labelStyles}
            valueStyles={{ color: blueColor04 }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

const ShipmentPreferenceDetails = ({
  label,
  selectedLsps,
  ondcLspProviders,
  bgcolor,
}) => {
  return (
    <Box
      sx={{
        bgcolor,
        borderRadius: "8px",
        p: "6px 12px 12px 12px",
      }}
    >
      <Typography fontSize={12.5} fontWeight={400} color={greyColor6} mb={0.6}>
        {label}
      </Typography>

      {selectedLsps?.length > 0 ? (
        <Grid container rowSpacing={{ xs: 0.5, md: 1 }} columnSpacing={4}>
          {ondcLspProviders
            ?.filter(
              (item) =>
                selectedLsps?.includes(item?.name) ||
                selectedLsps?.includes(item?.subscriber_id)
            )
            ?.map((item, index) => {
              return (
                <Grid item xs={6} md={4} key={`${item}_${index}`}>
                  <ListData value={item?.name} />
                </Grid>
              );
            })}
        </Grid>
      ) : (
        <Typography fontSize={12.5} fontWeight={500} color={blackColor}>
          N/A
        </Typography>
      )}
    </Box>
  );
};

const StyledSwitchBlack = ({ isChecked, onChange, label, gap, labelColor }) => {
  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 38,
    height: 20,
    padding: 0,
    cursor: "none !important",
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(17.5px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: displaySwitchGreenColor,
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },

      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: displaySwitchGreenColor,
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.grey[100],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 16,
      height: 16,
    },
    "& .MuiSwitch-track": {
      borderRadius: 22 / 2,
      backgroundColor: "rgba(0,0,0,0.2)",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  return (
    <Box display="flex" alignItems="center" gap={gap || "10px"} mt="4px">
      <IOSSwitch sx={{ m: 1 }} checked={isChecked} onChange={onChange} />

      <Typography
        component="body2"
        fontSize={14}
        color={labelColor || greyColor24}
        fontWeight={500}
        lineHeight="20px"
        sx={{ textDecoration: labelColor ? "underline" : "none" }}
      >
        {label}
      </Typography>
    </Box>
  );
};

const TitleText = ({ title, subtitle }) => {
  return (
    <Box display="flex" alignItems="center" gap="8px">
      <Box sx={styles.dotUi} />

      <Typography
        component="h6"
        fontSize={{ md: 14, xs: 14 }}
        color={greyColor24}
        fontWeight={600}
        lineHeight="18px"
        display={{ md: "inline", xs: "block" }}
      >
        {title}{" "}
        <Typography
          component="span"
          fontSize={{ md: 12, xs: 11.5 }}
          color={greyColor6}
          fontWeight={400}
          display={{ md: "inline", xs: "block" }}
          ml={{ md: "5px !important", xs: 0 }}
        >
          {subtitle}
        </Typography>
      </Typography>
    </Box>
  );
};

const styles = {
  section: {
    p: { xs: "0px 15px 10px", md: "0px 20px 10px" },
    backgroundColor: whiteColor,
    boxShadow: "0 0px 4px 0 rgb(0 0 0 / 5%)",
    borderRadius: { xs: "8px", md: "13px" },
    mt: { xs: "10px", md: "0px" },
  },

  labelStyles: {
    mb: { xs: 0.7, md: 0 },
  },

  dotUi: {
    width: { md: "6px", xs: "5px" },
    height: { md: "6px", xs: "5px" },
    borderRadius: "50%",
    backgroundColor: greyColor24,
    mt: -0.2,
  },
};
